import { Link } from 'react-router-dom';
import { useProductContext } from '@/context/ProductContext';

const badgeColors: Record<string, string> = {
  FAVORITO: 'bg-[#f9b8c8] text-[#2d1a0e]',
  NUEVO: 'bg-[#00b4c8] text-white',
  TEMPORADA: 'bg-[#fde68a] text-[#2d1a0e]',
  PERSONALIZABLE: 'bg-[#c9b8f0] text-[#2d1a0e]',
  CLÁSICO: 'bg-[#f9b8c8] text-[#2d1a0e]',
};

export default function FeaturedProducts() {
  const { products } = useProductContext();
  const featuredProducts = products.filter((p) => p.active && p.featured_month).slice(0, 4);

  if (featuredProducts.length === 0) return null;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <span className="text-xs font-semibold text-[#00b4c8] uppercase tracking-widest">
              Lo más pedido
            </span>
            <h2
              className="text-3xl md:text-4xl font-bold text-[#2d1a0e] mt-2"
            >
              Favoritos del Mes
            </h2>
          </div>
          <Link
            to="/menu"
            className="text-sm font-semibold text-[#00b4c8] flex items-center gap-1 hover:gap-2 transition-all cursor-pointer whitespace-nowrap"
          >
            Ver todos <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredProducts.map((product) => (
            <div
              key={product.id}
              className="group bg-[#e0f7fa]/30 rounded-2xl overflow-hidden hover:shadow-sm transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {product.badge && (
                  <span
                    className={`absolute top-3 left-3 text-xs font-bold px-2.5 py-1 rounded-full ${
                      badgeColors[product.badge] || 'bg-[#c9b8f0] text-[#2d1a0e]'
                    }`}
                  >
                    {product.badge}
                  </span>
                )}
              </div>
              <div className="p-5">
                <p className="text-xs text-[#00b4c8] font-medium mb-1">{product.category}</p>
                <h3 className="font-bold text-[#2d1a0e] text-base mb-1 leading-tight">
                  {product.name}
                </h3>
                <p className="text-xs text-[#6b5b6e] mb-4 leading-relaxed line-clamp-2">
                  {product.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-[#2d1a0e]">
                    <span className="text-sm font-normal text-[#7a5c44]">$</span>
                    {product.price}
                  </span>
                  <Link
                    to={`/menu?producto=${product.id}`}
                    className="flex items-center gap-1.5 text-xs font-semibold px-4 py-2 rounded-full bg-[#00b4c8] text-white hover:bg-[#0099aa] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-eye-line"></i> Ver Producto
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}